import React from "react";
import { Edit, useForm } from "@refinedev/antd";
import { Form, Input, InputNumber, Switch } from "antd";

export const TaxesEdit: React.FC = () => {
    const { formProps, saveButtonProps } = useForm({
        meta: {
            fields: ["id", "taxTypeId", "taxType", "rate", "isActive"]
        },
        successNotification: {
            message: "Tax updated successfully",
            description: "Tax information has been updated",
            type: "success"
        },
        errorNotification: {
            message: "Error updating tax",
            description: "There was an error updating the tax",
            type: "error"
        }
    });


    // Even if data isn't loaded, proceed with the form after initialDataLoaded is true
    return (
        <Edit
            saveButtonProps={saveButtonProps}
        >
                <Form
                    {...formProps}
                    layout="vertical"
                >
                    <Form.Item
                        label="ID"
                        name="id"
                        hidden
                    >
                        <Input id="id" disabled />
                    </Form.Item>

                    <Form.Item
                        label="Tax Type"
                        name="taxType"
                        rules={[{ required: true, message: "Tax type is required" }]}
                    >
                        <Input id="taxType" placeholder="e.g. VAT" />
                    </Form.Item>

                    <Form.Item
                        label="Tax ID"
                        name="taxTypeId"
                        rules={[{ required: true, message: "Tax ID is required" }]}
                    >
                        <Input id="taxTypeId" placeholder="e.g. 1" />
                    </Form.Item>

                    <Form.Item
                        label="Tax Rate (%)"
                        name="rate"
                        rules={[
                            { required: true, message: "Tax rate is required" },
                            { type: "number", min: 0, max: 100, message: "Rate must be between 0 and 100" }
                        ]}
                        tooltip="Enter the percentage rate (0-100)"
                    >
                        <InputNumber
                            id="rate"
                            min={0}
                            max={100}
                            precision={2}
                            style={{ width: "100%" }}
                            formatter={(value: number | string | undefined) => value !== undefined ? `${value}%` : ''}
                            parser={(value: string | undefined) => value ? value.replace('%', '') : ''}
                            placeholder="e.g. 10"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Is Active"
                        name="isActive"
                        valuePropName="checked"
                    >
                        <Switch id="isActive" />
                    </Form.Item>
                </Form>
        </Edit>
    );
};
